import { render } from "./TopbarAcadFilters.vue?vue&type=template&id=26f92546"
import script from "./TopbarAcadFilters.vue?vue&type=script&lang=js"
export * from "./TopbarAcadFilters.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3444732531/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__